<template>
    <div v-if="item">
        <div class="group flex flex-col h-full bg-white border border-gray-400 shadow-sm rounded-xl dark:bg-neutral-900 dark:border-neutral-700 dark:shadow-neutral-700/70">
            <router-link :to="'/formularios/create/' + item.codoId">
                <div class="p-4 md:p-6">
                    <span class="block mb-1 text-xs font-semibold uppercase text-blue-600 dark:text-blue-500">
                        {{ item.codoTipo }}
                    </span>
                    <h3 class="text-xl font-semibold text-gray-800 dark:text-neutral-300 dark:hover:text-white">
                        {{ item.codoNombre }}
                    </h3>
                    <p class="mt-3 text-gray-500 dark:text-neutral-500">
                        {{ item.codoDescripcion }}
                    </p>
                </div>
            </router-link>
            <div class="mt-auto flex border-t border-gray-400 divide-x divide-gray-200 dark:border-neutral-700 dark:divide-neutral-700">
                <router-link :to="'/formularios/create/' + item.codoId" class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-es-xl text-blue-600 hover:bg-blue-100  hover:text-blue-800 focus:outline-none focus:bg-blue-100 focus:text-blue-800 disabled:opacity-50 disabled:pointer-events-none dark:text-blue-500 dark:hover:bg-blue-800/30 dark:hover:text-blue-400 dark:focus:bg-blue-800/30 dark:focus:text-blue-400">
                    Editar
                </router-link>
                <a href="javascript:;" @click="() => functionDelete && functionDelete(item?.codoId)" class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-ee-xl text-red-500 hover:bg-red-100 focus:outline-none focus:bg-red-100 hover:text-red-800 disabled:opacity-50 disabled:pointer-events-none dark:hover:bg-red-800/30 dark:hover:text-red-400 dark:focus:bg-red-800/30 dark:focus:text-red-400">
                    Eliminar
                </a>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
defineProps({
  item: Object,
  functionDelete:Function
})
</script>